<template lang="pug">
.text-field-study(:style='setStyle')
  textarea.text-field-study__input(
    ref='textField',
    @input='updateValue',
    @focus='resize',
    :value='value',
    :placeholder='placeholder',
    @keydown.enter.prevent
  )
  .text-field-study__dummy-field(ref='dummyField') {{ value }}
</template>

<script lang="ts">
import { Component, Prop, Vue, Ref, Watch } from 'vue-property-decorator'

const WIDTH_GAP = 4

/**
 * 学習用テキストフィールド
 * 入力値の長さに応じて入力欄がリサイズされる
 */
@Component
export default class TextFieldStudy extends Vue {
  private resizeWidth = 0
  private resizeHeight = 0

  // 入力値
  @Prop()
  value!: string

  // プレースホルダー（任意）
  @Prop()
  placeholder?: string

  // 入力欄の最大幅
  @Prop()
  maxWidth!: number

  // ダミーフィールドref
  @Ref() dummyField!: HTMLElement

  // 入力フィールドref
  @Ref() textField!: HTMLElement

  private updateValue(event: Event): void {
    this.$emit('input', (event.target as HTMLInputElement).value)
  }

  private get setStyle(): { [key: string]: string } {
    return {
      '--text-field-width': `${this.resizeWidth}px`,
      '--text-field-height': `${this.resizeHeight}px`,
      '--dummy-field-max-width': `${this.maxWidth - WIDTH_GAP}px`,
    }
  }

  /**
   * ダミーフィールドの縦横サイズを入力欄に反映
   */
  private resize() {
    if (!this.dummyField) return

    this.$nextTick(() => {
      this.resizeWidth = this.dummyField.clientWidth + WIDTH_GAP
      this.resizeHeight = this.dummyField.clientHeight
    })
  }

  private mounted() {
    this.resize()
  }

  @Watch('value')
  private onValueInput() {
    this.resize()
  }

  // 入力フィールドにフォーカスする
  public focus() {
    this.textField.focus()
  }
}
</script>

<style lang="stylus" scoped>
.text-field-study
  display flex
  &__input
    overflow hidden
    resize none
    width var(--text-field-width)
    height var(--text-field-height)
    border-radius 4px
    padding 4px
  &__dummy-field
    min-height var(--input-height-default)
    min-width 156px
    max-width var(--dummy-field-max-width)
    visibility hidden
    position fixed
    line-break anywhere
    padding 4px
</style>
